import { Sparkles } from "lucide-react";
import { getLucideIcon } from "@/shared/utils/lucideIcon.utils";
import {
  CARD_BACKGROUNDS,
  COLOR_CHARCOAL,
  COLOR_MUTED,
} from "../constants/upsellPage.constants";
import MediaCard from "./primitives/MediaCard";
import type { BenefitsGridProps } from "../types/upsellPage.types";

const BenefitsGrid = ({ features }: BenefitsGridProps) => {
  return (
    <section className="mx-auto w-full max-w-5xl px-4 py-20 sm:py-24">
      <div className="mb-14 flex flex-col items-center text-center">
        <h2
          className="animate-upsell-fade-in-up font-light tracking-tight"
          style={{
            color: COLOR_CHARCOAL,
            fontSize: "clamp(1.875rem, 3.5vw, 2.625rem)",
            lineHeight: 1.15,
            letterSpacing: "-0.015em",
            animationDelay: "0.05s",
          }}
        >
          Ce qui est inclus
        </h2>
        <p
          className="animate-upsell-fade-in-up mt-4 max-w-lg text-base sm:text-lg"
          style={{
            color: COLOR_MUTED,
            lineHeight: 1.55,
            animationDelay: "0.1s",
          }}
        >
          Tout ce dont vous avez besoin pour faire passer votre CSE au niveau supérieur, en un seul plan.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, index) => {
          const BenefitIcon = getLucideIcon(feature.icon) ?? Sparkles;
          return (
            <MediaCard
              key={feature.text}
              backgroundUrl={CARD_BACKGROUNDS[index % CARD_BACKGROUNDS.length]}
              revealDelay={index}
              media={(
                <BenefitIcon
                  size={32}
                  strokeWidth={1.75}
                  style={{ color: COLOR_CHARCOAL }}
                  aria-hidden="true"
                />
              )}
              body={(
                <p
                  className="font-medium leading-snug"
                  style={{
                    color: COLOR_CHARCOAL,
                    fontSize: "16px",
                  }}
                >
                  {feature.text}
                </p>
              )}
            />
          );
        })}
      </div>
    </section>
  );
};

export default BenefitsGrid;
